import { Component } from 'react';
import PropTypes from 'prop-types';

export default class Circle extends Component {
  constructor(props) {
    super(props);
    this.shape = null;
  }

  componentWillMount() {
    // Throw warning if map, maps,. handelboudns havnet been defined

    this.shape = new this.props.maps.Circle({
      clickable: !!this.props.info,
      strokeColor: this.props.strokeColor,
      strokeOpacity: this.props.strokeOpacity,
      strokeWeight: this.props.strokeWeight,
      fillColor: this.props.fillColor,
      fillOpacity: this.props.fillOpacity,
      map: this.props.map,
      center: { lat: this.props.coordinates.lat, lng: this.props.coordinates.lng },
      radius: this.props.radius, // In meters.
    });

    if (this.props.info) {
      this.infoWindow = new this.props.maps.InfoWindow({
        content: this.props.info.content,
        position: { lat: this.props.coordinates.lat, lng: this.props.coordinates.lng },
      });
      this.openInfoWindow = () => this.infoWindow.open(this.props.map, this.shape);

      this.shape.addListener('click', this.openInfoWindow);
    }

    this.props.handleBounds(this.shape.getBounds());
    this.shape.setMap(this.props.map);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.map !== nextProps.map) {
      this.shape.setMap(nextProps.map);
    }

    if (this.props.coordinates.lat !== nextProps.coordinates.lat ||
      this.props.coordinates.lng !== nextProps.coordinates.lng) {
      const center = { lat: nextProps.coordinates.lat, lng: nextProps.coordinates.lng };
      this.shape.setCenter(center);

      if (this.infoWindow) {
        this.infoWindow.setCenter(center);
      }

      this.props.handleBounds(this.shape.getBounds());
    }

    if (this.props.radius !== nextProps.radius) {
      this.shape.setRadius(nextProps.radius);
      this.props.handleBounds(this.shape.getBounds());
    }
  }

  componentWillUnmount() {
    this.props.handleBounds(null);
    this.shape.setMap(null);
  }

  render() {
    return null;
  }
}

Circle.defaultProps = {
  info: undefined,
  strokeColor: '#FF0000',
  strokeOpacity: 0.8,
  strokeWeight: 2,
  fillColor: '#FF0000',
  fillOpacity: 0.35,
};

Circle.propTypes = {
  coordinates: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }).isRequired,
  radius: PropTypes.number.isRequired,
  handleBounds: PropTypes.func.isRequired,

  // Info
  info: PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  }),

  // Styling
  strokeColor: PropTypes.string,
  strokeOpacity: PropTypes.number,
  strokeWeight: PropTypes.number,
  fillColor: PropTypes.string,
  fillOpacity: PropTypes.number,

  // Google Maps map instance
  map: PropTypes.object.isRequired, // eslint-disable-line
  // Google Maps lib reference
  maps: PropTypes.object.isRequired, // eslint-disable-line
};
